export default "__VITE_PUBLIC_ASSET__cf7b73ae__"